var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 49,
    viewBox: "0 0 163 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.603509,
    y: 0.603509,
    width: 161.74,
    height: 47.0737,
    rx: 5.43158,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.603509,
    y: 0.603509,
    width: 161.74,
    height: 47.0737,
    rx: 5.43158,
    stroke: "#A6A6A6",
    strokeWidth: 1.20702
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2425 26.2535C79.4036 26.2535 77.0897 28.4128 77.0897 31.3869C77.0897 34.3429 79.4036 36.5204 82.2425 36.5204C85.0826 36.5204 87.3964 34.3429 87.3964 31.3869C87.3952 28.4128 85.0814 26.2535 82.2425 26.2535ZM82.2425 34.4998C80.6866 34.4998 79.3456 33.2168 79.3456 31.3881C79.3456 29.5402 80.6878 28.2764 82.2425 28.2764C83.7983 28.2764 85.1393 29.5402 85.1393 31.3881C85.1393 33.2156 83.7983 34.4998 82.2425 34.4998ZM71.0003 26.2535C68.1614 26.2535 65.8476 28.4128 65.8476 31.3869C65.8476 34.3429 68.1614 36.5204 71.0003 36.5204C73.8404 36.5204 76.1543 34.3429 76.1543 31.3869C76.1543 28.4128 73.8404 26.2535 71.0003 26.2535ZM71.0003 34.4998C69.4445 34.4998 68.1035 33.2168 68.1035 31.3881C68.1035 29.5402 69.4457 28.2764 71.0003 28.2764C72.5562 28.2764 73.8972 29.5402 73.8972 31.3881C73.8984 33.2156 72.5562 34.4998 71.0003 34.4998ZM57.629 27.8298V30.0073H62.8409C62.6852 31.2324 62.2772 32.1268 61.6544 32.7484C60.8964 33.5064 59.7099 34.3429 57.629 34.3429C54.4207 34.3429 51.9125 31.7563 51.9125 28.548C51.9125 25.3398 54.4207 22.7531 57.629 22.7531C59.3598 22.7531 60.6236 23.4339 61.5566 24.309L63.0932 22.7724C61.7896 21.528 60.0599 20.5757 57.629 20.5757C53.2342 20.5757 49.5396 24.1533 49.5396 28.548C49.5396 32.9428 53.2342 36.5204 57.629 36.5204C60.0008 36.5204 61.7908 35.7418 63.1897 34.2838C64.6285 32.845 65.0763 30.822 65.0763 29.1889C65.0763 28.6844 65.0377 28.2173 64.9592 27.8286H57.629V27.8298ZM112.317 29.5209C111.889 28.3742 110.586 26.2535 107.922 26.2535C105.277 26.2535 103.079 28.3344 103.079 31.3869C103.079 34.2645 105.258 36.5204 108.174 36.5204C110.527 36.5204 111.888 35.0816 112.453 34.2451L110.703 33.078C110.12 33.9337 109.322 34.4974 108.174 34.4974C107.027 34.4974 106.21 33.9724 105.685 32.9416L112.549 30.1027L112.317 29.5209ZM105.316 31.2324C105.258 29.2481 106.852 28.2378 108 28.2378C108.895 28.2378 109.653 28.6856 109.906 29.3265L105.316 31.2324ZM99.7358 36.2102H101.991V21.1212H99.7358V36.2102ZM96.0399 27.4014H95.9627C95.4569 26.7978 94.4841 26.2535 93.2601 26.2535C90.6928 26.2535 88.3403 28.5094 88.3403 31.4074C88.3403 34.285 90.6928 36.5216 93.2601 36.5216C94.4853 36.5216 95.4569 35.9772 95.9627 35.3556H96.0399V36.0943C96.0399 38.0581 94.9898 39.1082 93.2988 39.1082C91.9179 39.1082 91.0622 38.1173 90.7121 37.2808L88.7483 38.0979C89.312 39.4583 90.8087 41.1312 93.2988 41.1312C95.9433 41.1312 98.1799 39.5753 98.1799 35.7829V26.5661H96.0411V27.4014H96.0399ZM93.4545 34.4998C91.8986 34.4998 90.5963 33.1962 90.5963 31.4074C90.5963 29.5981 91.8986 28.2764 93.4545 28.2764C94.9898 28.2764 96.1956 29.5981 96.1956 31.4074C96.1956 33.1962 94.9898 34.4998 93.4545 34.4998ZM122.883 21.1212H117.486V36.2102H119.737V30.4937H122.882C125.378 30.4937 127.833 28.6868 127.833 25.8081C127.833 22.9294 125.379 21.1212 122.883 21.1212ZM122.941 28.3935H119.737V23.2215H122.941C124.624 23.2215 125.58 24.6156 125.58 25.8081C125.58 26.9765 124.624 28.3935 122.941 28.3935ZM136.86 26.2269C135.229 26.2269 133.541 26.9451 132.842 28.5372L134.841 29.3712C135.268 28.5372 136.065 28.2644 136.899 28.2644C138.063 28.2644 139.248 28.9632 139.267 30.2053V30.361C138.859 30.128 137.985 29.7792 136.918 29.7792C134.763 29.7792 132.569 30.9633 132.569 33.1757C132.569 35.1951 134.336 36.495 136.316 36.495C137.829 36.495 138.665 35.8155 139.188 35.0188H139.266V36.1836H141.441V30.3984C141.442 27.7212 139.441 26.2269 136.86 26.2269ZM136.587 34.4962C135.851 34.4962 134.821 34.1269 134.821 33.2144C134.821 32.0496 136.103 31.603 137.21 31.603C138.199 31.603 138.666 31.8166 139.267 32.1075C139.092 33.5064 137.888 34.4962 136.587 34.4962ZM149.361 26.5564L146.779 33.0985H146.702L144.022 26.5564H141.596L145.615 35.6996L143.324 40.786H145.672L151.866 26.5564H149.361ZM129.076 36.2102H131.327V21.1212H129.076V36.2102Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2339 12.3635C57.2339 13.375 56.9345 14.18 56.3346 14.7811C55.6539 15.4957 54.7655 15.853 53.6744 15.853C52.6291 15.853 51.7395 15.4909 51.0093 14.7667C50.2778 14.0412 49.9121 13.1432 49.9121 12.0714C49.9121 10.9984 50.2778 10.1003 51.0093 9.37612C51.7395 8.6507 52.6291 8.2886 53.6744 8.2886C54.1934 8.2886 54.6895 8.38999 55.1602 8.59156C55.6322 8.79434 56.01 9.0635 56.2924 9.40026L55.6563 10.0376C55.1771 9.46423 54.5169 9.17817 53.6732 9.17817C52.9103 9.17817 52.2513 9.44613 51.6949 9.98204C51.1384 10.518 50.8608 11.2144 50.8608 12.0702C50.8608 12.926 51.1384 13.6224 51.6949 14.1583C52.2513 14.6942 52.9103 14.9622 53.6732 14.9622C54.4819 14.9622 55.1566 14.693 55.6961 14.1535C56.0462 13.8023 56.2489 13.3134 56.3033 12.687H53.6732V11.8167H57.182C57.2182 12.0062 57.2339 12.1885 57.2339 12.3635Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7983 9.33877H59.5008V11.6345H62.4749V12.5048H59.5008V14.8005H62.7983V15.6913H58.5702V8.4492H62.7983V9.33877Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7222 15.6913H65.7916V9.33877H63.7686V8.4492H68.7452V9.33877H66.7222V15.6913Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3457 15.6913V8.4492H73.2763V15.6913H72.3457Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4033 15.6913H76.4727V9.33877H74.4497V8.4492H79.4262V9.33877H77.4033V15.6913Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8467 14.7559C88.1346 15.4873 87.2498 15.853 86.1913 15.853C85.1327 15.853 84.248 15.4873 83.5371 14.7559C82.8249 14.0244 82.47 13.1288 82.47 12.0702C82.47 11.0117 82.8249 10.1161 83.5371 9.38463C84.248 8.65317 85.1327 8.28624 86.1913 8.28624C87.2438 8.28624 88.1273 8.65438 88.8419 9.38945C89.5565 10.1245 89.9137 11.0177 89.9137 12.0702C89.9137 13.1288 89.5577 14.0244 88.8467 14.7559ZM84.2238 14.1487C84.7598 14.6919 85.4152 14.9623 86.1913 14.9623C86.9674 14.9623 87.624 14.6907 88.1587 14.1487C88.6946 13.6056 88.9638 12.9127 88.9638 12.0702C88.9638 11.2277 88.6946 10.5349 88.1587 9.99176C87.624 9.4486 86.9674 9.17823 86.1913 9.17823C85.4152 9.17823 84.7598 9.4498 84.2238 9.99176C83.6891 10.5349 83.42 11.2277 83.42 12.0702C83.42 12.9127 83.6891 13.6056 84.2238 14.1487Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2197 15.6913V8.4492H92.3519L95.8716 14.0823H95.9114L95.8716 12.687V8.4492H96.8022V15.6913H95.8306L92.1479 9.78416H92.1081L92.1479 11.1795V15.6913H91.2197Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2339 12.3635C57.2339 13.375 56.9345 14.18 56.3346 14.7811C55.6539 15.4957 54.7655 15.853 53.6744 15.853C52.6291 15.853 51.7395 15.4909 51.0093 14.7667C50.2778 14.0412 49.9121 13.1432 49.9121 12.0714C49.9121 10.9984 50.2778 10.1003 51.0093 9.37612C51.7395 8.6507 52.6291 8.2886 53.6744 8.2886C54.1934 8.2886 54.6895 8.38999 55.1602 8.59156C55.6322 8.79434 56.01 9.0635 56.2924 9.40026L55.6563 10.0376C55.1771 9.46423 54.5169 9.17817 53.6732 9.17817C52.9103 9.17817 52.2513 9.44613 51.6949 9.98204C51.1384 10.518 50.8608 11.2144 50.8608 12.0702C50.8608 12.926 51.1384 13.6224 51.6949 14.1583C52.2513 14.6942 52.9103 14.9622 53.6732 14.9622C54.4819 14.9622 55.1566 14.693 55.6961 14.1535C56.0462 13.8023 56.2489 13.3134 56.3033 12.687H53.6732V11.8167H57.182C57.2182 12.0062 57.2339 12.1885 57.2339 12.3635Z",
    stroke: "white",
    strokeWidth: 0.241404,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7983 9.33877H59.5008V11.6345H62.4749V12.5048H59.5008V14.8005H62.7983V15.6913H58.5702V8.4492H62.7983V9.33877Z",
    stroke: "white",
    strokeWidth: 0.241404,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7222 15.6913H65.7916V9.33877H63.7686V8.4492H68.7452V9.33877H66.7222V15.6913Z",
    stroke: "white",
    strokeWidth: 0.241404,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3457 15.6913V8.4492H73.2763V15.6913H72.3457Z",
    stroke: "white",
    strokeWidth: 0.241404,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4033 15.6913H76.4727V9.33877H74.4497V8.4492H79.4262V9.33877H77.4033V15.6913Z",
    stroke: "white",
    strokeWidth: 0.241404,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8467 14.7559C88.1346 15.4873 87.2498 15.853 86.1913 15.853C85.1327 15.853 84.248 15.4873 83.5371 14.7559C82.8249 14.0244 82.47 13.1288 82.47 12.0702C82.47 11.0117 82.8249 10.1161 83.5371 9.38463C84.248 8.65317 85.1327 8.28624 86.1913 8.28624C87.2438 8.28624 88.1273 8.65438 88.8419 9.38945C89.5565 10.1245 89.9137 11.0177 89.9137 12.0702C89.9137 13.1288 89.5577 14.0244 88.8467 14.7559ZM84.2238 14.1487C84.7598 14.6919 85.4152 14.9623 86.1913 14.9623C86.9674 14.9623 87.624 14.6907 88.1587 14.1487C88.6946 13.6056 88.9638 12.9127 88.9638 12.0702C88.9638 11.2277 88.6946 10.5349 88.1587 9.99176C87.624 9.4486 86.9674 9.17823 86.1913 9.17823C85.4152 9.17823 84.7598 9.4498 84.2238 9.99176C83.6891 10.5349 83.42 11.2277 83.42 12.0702C83.42 12.9127 83.6891 13.6056 84.2238 14.1487Z",
    stroke: "white",
    strokeWidth: 0.241404,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2197 15.6913V8.4492H92.3519L95.8716 14.0823H95.9114L95.8716 12.687V8.4492H96.8022V15.6913H95.8306L92.1479 9.78416H92.1081L92.1479 11.1795V15.6913H91.2197Z",
    stroke: "white",
    strokeWidth: 0.241404,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_165_14776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5962 9.09878C12.245 9.47054 12.0374 10.0475 12.0374 10.7946V37.489C12.0374 38.2374 12.245 38.8131 12.5962 39.1849L12.6855 39.2718L27.6393 24.3181V24.1418V23.9656L12.6855 9.01067L12.5962 9.09878Z",
    fill: "url(#paint0_linear_165_14776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6227 29.304L27.6389 24.3178V24.1416V23.9653L32.6239 18.9803L32.7362 19.0443L38.6421 22.3998C40.3283 23.3582 40.3283 24.9261 38.6421 25.8857L32.7362 29.2412L32.6227 29.304Z",
    fill: "url(#paint1_linear_165_14776)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_165_14776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7364 29.2398L27.6379 24.1414L12.5961 39.1845C13.1513 39.7735 14.0698 39.8459 15.1043 39.2593L32.7364 29.2398Z",
    fill: "url(#paint2_linear_165_14776)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.7364 19.0432L15.1043 9.02497C14.0698 8.43715 13.1513 8.51078 12.5961 9.09981L27.6391 24.1429L32.7364 19.0432Z",
    fill: "url(#paint3_linear_165_14776)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_165_14776",
    x: 12.0374,
    y: 8.61932,
    width: 27.8694,
    height: 31.0452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.181053
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_165_14776"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.181053
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_165_14776",
    result: "effect2_innerShadow_165_14776"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_165_14776",
    x: 12.5961,
    y: 24.1414,
    width: 20.1403,
    height: 15.5231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.181053
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_165_14776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_14776",
    x1: 26.3137,
    y1: 10.5122,
    x2: 6.05755,
    y2: 30.7684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_14776",
    x1: 40.837,
    y1: 24.1416,
    x2: 11.6322,
    y2: 24.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_165_14776",
    x1: 29.9676,
    y1: 26.9102,
    x2: 2.49768,
    y2: 54.3801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_165_14776",
    x1: 8.80772,
    y1: 0.213503,
    x2: 21.0738,
    y2: 12.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.04254eb2838aeb467a1276669866a435.svg";
export { ForwardRef as ReactComponent };